var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwsRedshift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 18.5781L20.24 20.7781V3.47095L11 5.67095V18.5781Z",
    fill: "#205B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2401 3.47095L22.0001 4.35095V19.8981L20.2401 20.7781V3.47095ZM11 18.5781L1.76001 20.7781V3.47095L11 5.67095V18.5781Z",
    fill: "#5193CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76 3.47095L0 4.35095V19.8981L1.76 20.7781V3.47095Z",
    fill: "#205B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3471 24.2981L16.867 22.5381V1.76L13.3471 0L12.271 11.5381L13.3471 24.2981Z",
    fill: "#5193CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65294 24.2981L5.13293 22.5381V1.76L8.65294 0L9.7291 11.5381L8.65294 24.2981Z",
    fill: "#205B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65295 0H13.3948V24.249H8.65295V0Z",
    fill: "#2E73B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24.2981,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsRedshift);
export default __webpack_public_path__ + "static/media/aws-redshift.827cf4e93731f5e9e69a9a51f38ca83d.svg";
export { ForwardRef as ReactComponent };